import React, { Component } from 'react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { RouteComponentProps } from 'react-router';
import { Button, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouterWorkaround } from 'utils/workaroundUtils';

const StyledHeaderSpan = styled.span`
  font-weight: bold;
  padding-left: 1rem;
  vertical-align: middle;
  font-size: 1.3rem !important;
  line-height: 2rem;
`;

const ActionsToolbar = styled.div`
  padding: 0.5rem;
  padding-bottom: 2rem !important;
  padding-left: 0;
`;

interface Props extends MessageSourceProps, RouteComponentProps {
  className?: string,

}

interface State {
}

class ClinicalDataRecordViewHeader extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
  };

  render(): React.ReactNode {

    const {
      className,
      getMessage,
      history
    } = this.props;

    return (
        <ActionsToolbar className={`page-header ${className}`}>
          <StyledHeaderSpan className="title">
            {getMessage("clinicalData.home.title.main")}
          </StyledHeaderSpan>
          <Button
              floated={'right'}
              compact
              size="small"
              onClick={() => history.push("/clinical-data-record/requires-action")}
          >
            <Icon name="warning circle"/>
            {getMessage("patientRecord.patientDocument.requiresAction")}
          </Button>

          <Button
              floated={'right'}
              compact
              size="small"
              onClick={() => history.push("/clinical-data-record/procedure-created")}
          >
            <Icon name="warning circle"/>
            {getMessage("patientRecord.patientDocument.procedureCreated")}
          </Button>
        </ActionsToolbar>
    );
  }

}

export default withMessages(withRouterWorkaround(ClinicalDataRecordViewHeader));
